/* eslint-disable prefer-rest-params, no-continue, lines-around-directive */
export default function ReplaceWith(Ele: HTMLElement) {
    'use-strict'; // For safari, and IE > 10
    const parent = this.parentNode;
    let i = arguments.length;
    const firstIsNode = +(parent && typeof Ele === 'object');
    if (!parent) return;

    while (i-- > firstIsNode) {
        if (parent && typeof arguments[i] !== 'object') {
            arguments[i] = document.createTextNode(arguments[i]);
        }
        if (!parent && arguments[i].parentNode) {
            arguments[i].parentNode.removeChild(arguments[i]);
            continue;
        }
        parent.insertBefore(this.previousSibling, arguments[i]);
    }
    if (firstIsNode) parent.replaceChild(Ele, this);
}
